import adminAxios from './adminAxios';

export const fetchFinanceStatsApi = (params) => adminAxios.get('/finance/stats', { params });

export const fetchIncomesApi = (params) => adminAxios.get('/finance/income', { params });
export const createIncomeApi = (data) => adminAxios.post('/finance/income', data);
export const updateIncomeApi = (id, data) => adminAxios.put(`/finance/income/${id}`, data);
export const deleteIncomeApi = (id) => adminAxios.delete(`/finance/income/${id}`);
export const bulkUploadIncomesApi = (data) => adminAxios.post('/finance/income/bulk', data);

export const fetchExpensesApi = (params) => adminAxios.get('/finance/expense', { params });
export const createExpenseApi = (data) => adminAxios.post('/finance/expense', data);
export const updateExpenseApi = (id, data) => adminAxios.put(`/finance/expense/${id}`, data);
export const deleteExpenseApi = (id) => adminAxios.delete(`/finance/expense/${id}`);
export const bulkUploadExpensesApi = (data) => adminAxios.post('/finance/expense/bulk', data);

export const syncAuditionIncomeApi = () => adminAxios.post('/finance/sync-audition-income');
export const fetchPNLReportApi = (params) => adminAxios.get('/finance/pnl-report', { params });
